/**
 * Heuro Cinema - Modal Controller
 * Handles the demo request modal.
 */

export function showModal(): void {
  const modal = document.getElementById('demoModal');
  modal?.classList.add('visible');
}

export function hideModal(): void {
  const modal = document.getElementById('demoModal');
  modal?.classList.remove('visible');
}

export function initModal(): void {
  const modal = document.getElementById('demoModal');
  const closeBtn = document.getElementById('modalClose');
  const form = document.getElementById('demoForm');

  // Close button
  closeBtn?.addEventListener('click', hideModal);

  // Click outside to close
  modal?.addEventListener('click', (e) => {
    if (e.target === modal) {
      hideModal();
    }
  });

  // Form submission
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const nameInput = document.getElementById('formName') as HTMLInputElement;
    const emailInput = document.getElementById('formEmail') as HTMLInputElement;
    const companyInput = document.getElementById('formCompany') as HTMLInputElement;

    const data = {
      name: nameInput?.value || '',
      email: emailInput?.value || '',
      company: companyInput?.value || '',
      timestamp: new Date().toISOString(),
    };

    console.log('Form submitted:', data);

    // TODO: POST to /api/leads when backend supports it
    // For now, just close the modal
    hideModal();

    // Reset form
    (form as HTMLFormElement).reset();
  });
}

export function updateModalI18n(i18n: {
  title: string;
  subtitle: string;
  form: {
    name: string;
    email: string;
    company: string;
    consent: string;
    submit: string;
  };
}): void {
  const title = document.getElementById('modalTitle');
  const subtitle = document.getElementById('modalSubtitle');
  const nameLabel = document.getElementById('formNameLabel');
  const emailLabel = document.getElementById('formEmailLabel');
  const companyLabel = document.getElementById('formCompanyLabel');
  const consentLabel = document.getElementById('formConsentLabel');
  const submitBtn = document.getElementById('formSubmit');

  if (title) title.textContent = i18n.title;
  if (subtitle) subtitle.textContent = i18n.subtitle;
  if (nameLabel) nameLabel.textContent = i18n.form.name;
  if (emailLabel) emailLabel.textContent = i18n.form.email;
  if (companyLabel) companyLabel.textContent = i18n.form.company;
  if (consentLabel) consentLabel.textContent = i18n.form.consent;
  if (submitBtn) submitBtn.textContent = i18n.form.submit;
}